const editing = {
  name: 'Rikzan Fernanda',
  note: 'Graphic Designer | Photo Editor',
  summary:
    'The tools I use are Adobe Illustrator and Photoshop. I have more than 3 years experience in graphic design. Making a quality design requires several considerations such as the target audience and creative content. In making designs, I like to make designs that are modern, simple, clean, functional, stylish and keep up with the times. Like some of my work at: https://www.behance.net/rikzan_fernanda',
  links: {
    linkedin: 'https://www.linkedin.com/in/rikzan-fernanda-9097831ab/',
    github: 'https://github.com/rikzanfernanda'
  }
}

export default editing
